import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { IDeviceSettingsDefaultValueService } from '../../device-settings-default-value.interface';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { PowerSettingsService } from 'src/app/services/power/power-settings/power-settings.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { FlipToBootSetStatusEnum } from 'src/app/services/power/flipToBoot.enum';

@Injectable({
	providedIn: 'root'
})
export class PowerSettingsDefaultValueService implements IDeviceSettingsDefaultValueService {
	readonly TOGGLE_OFF: boolean = false;
	readonly UNCHECKED: boolean = false;

	constructor(
		private powerSettingsService: PowerSettingsService,
		private logger: LoggerService) { }

	initialize(adTags: any): void {
		if (!adTags) return;

		const powerSettings = _.get(adTags, DeviceSettingsFeatureToggle.PowerSettings);
		if (powerSettings === ADPolicyState.ENABLED) {
			this.setAlwaysOnUSB();
			this.setAirplaneMode();
			this.setEasyResume();
			this.setFlipToBoot();
		}
	}

	private async setAlwaysOnUSB(): Promise<void> {
		await this.setAlwaysOnUSBStatus();
		await this.setUSBCharging();
	}

	private async setAlwaysOnUSBStatus(): Promise<void> {
		try {
			const alwaysUSBCapability = await this.powerSettingsService.getAlwaysOnUSBCapability();
			this.logger.info('PowerSettingsDefaultValueService - setAlwaysOnUSB', alwaysUSBCapability);

			if (alwaysUSBCapability) {
				await this.powerSettingsService.setAlwaysOnUSBStatus(this.TOGGLE_OFF);
			}
		} catch (error) {
			this.logger.error('PowerSettingsDefaultValueService - setAlwaysOnUSBDefaultValue - error', error);
		}
	}

	private async setUSBCharging(): Promise<void> {
		try {
			const usbChargingCapability = await this.powerSettingsService.getUSBChargingCapability();
			this.logger.info('PowerSettingsDefaultValueService - setUSBCharging', usbChargingCapability);

			if (usbChargingCapability) {
				await this.powerSettingsService.setUSBCharging(this.UNCHECKED);
			}
		} catch (error) {
			this.logger.error('PowerSettingsDefaultValueService - setUSBChargingDefaultValue - error', error);
		}
	}

	private async setAirplaneMode(): Promise<void> {
		try {
			const airplaneModeCapability = await this.powerSettingsService.getAirplaneModeCapability();
			this.logger.info('PowerSettingsDefaultValueService - setAirplaneMode', airplaneModeCapability);

			if (airplaneModeCapability) {
				await this.powerSettingsService.setAirplaneMode(this.TOGGLE_OFF);
				await this.powerSettingsService.setAirplaneModeAutoDetection(this.UNCHECKED);
			}
		} catch (error) {
			this.logger.error('PowerSettingsDefaultValueService - setAirplaneMode - Error', error);
		}
	}

	private async setEasyResume(): Promise<void> {
		try {
			const easyResumeCapability = await this.powerSettingsService.getEasyResumeCapability();
			this.logger.info('PowerSettingsDefaultValueService - setEasyResume', easyResumeCapability);

			if (easyResumeCapability) {
				await this.powerSettingsService.setEasyResume(this.TOGGLE_OFF);
			}
		} catch (error) {
			this.logger.error('PowerSettingsDefaultValueService - setEasyResume - Error', error);
		}
	}

	private async setFlipToBoot(): Promise<void> {
		try {
			const flipToBootCapability = await this.powerSettingsService.getFlipToBootCapability();
			this.logger.info('PowerSettingsDefaultValueService - setFlipToBoot', flipToBootCapability);

			if (flipToBootCapability) {
				await this.powerSettingsService.setFlipToBoot(FlipToBootSetStatusEnum.Off);
			}
		} catch (error) {
			this.logger.error('PowerSettingsDefaultValueService - setFlipToBoot - Error', error);
		}
	}
}
